import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { LabService } from "../lab.service";
import { Observable } from "rxjs";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { fuseAnimations } from "../../../../../../@fuse/animations";
import { StorageService } from "../../../common/service/storage.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Globals } from "../../../common/global";
import { ApiService } from "app/main/module/common/service/api.service";
import { TranslateService } from "@ngx-translate/core";
import { DateAdapter } from "@angular/material/core";
import { ProfileService } from "../../profile/profile.service";
import { ReminderService } from "../../Cases/reminder/reminder-popup/reminder-popup.service";

@Component({
    selector: "app-labsetting",
    templateUrl: "./labsetting.component.html",
    styleUrls: ["./labsetting.component.scss"],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class LabsettingComponent implements OnInit {
    centresType: any;
    // labList: Array<string>;
    settingFormOne: FormGroup;
    settingFormTwo: FormGroup;
    settingFormThree: FormGroup;
    settingFormFour: FormGroup;
    currentLab = this.userService.getCookie("lab_id");
    selectedLab = this.userService.getCookie("lab_id");
    currentUser = this.userService.getCookie("email");
    currentTimeZone = this.userService.getCookie("defaultTz");
    timeZoneList = [
        "America/Toronto",
        "Asia/Dubai",
        "Asia/Kolkata",
        "Asia/Muscat",
        "Asia/Qatar",
        "Asia/Riyadh",
    ];
    currentCenter = this.userService.getCookie("center");
    selectedCenter = this.userService.getCookie("center");
    role = this.userService.getCookie("role");
    currentRoleData: any;
    errorMessage: any;
    userLabsData: Array<any>;
    labsData: Array<any>;
    Labs: any;
    lablist: Array<any> = [];
    newlablist: Array<any> = [];
    memberInfo: any;
    memberId: any;
    ismultiCenter: string;
    centers: string;
    userId: any;
    totalLabs: any;
    uesrDocId: any;

    can_change_centre: any;
    can_change_lab: any;
    // can_select_as_role: any;
    allConfigurationByrole: Array<any> = [];
    existingUserLabs: Array<any> = [];
    labsDataIdsforSupport: Array<any> = [];
    existingUserLabIDs: Array<any> = [];
    changedCenter: any;
    labsDetail: any;
    multi_center: any;
    languages: any = [
        { name: "LabSettings.English", code: "en" },
        { name: "LabSettings.French", code: "fr" },
    ];
    currentLanguage: string = "en";
    email: any;
    existingCenter: any;

    constructor(
        public labService: LabService,
        private apiService: ApiService,
        private formBuilder: FormBuilder,
        private userService: StorageService,
        private router: Router,
        public globals: Globals,
        private apiservice: ApiService,
        private translate: TranslateService,
        private dateAdapter: DateAdapter<Date>,
        public reminderService: ReminderService,
    ) {}

    ngOnInit(): void {
        this.getROleconfiguration();
        this.getuserDatails();
        this.role = this.userService.getCookie("role");
        this.email = this.userService.getCookie("email");
        this.currentLanguage = this.userService.getCookie("language") || "en";
        // // // console.log(e);
        this.getuserdatafromLabs().then(() => {
            if (this.role === "support") {
                this.getuserdatafromLabs().then(() => {
                    this.getLabArrayForExistRecordComaparission();
                    // console.log(this.role);
                });
            } else {
                this.getuserdatafromUser().then(() => {
                    this.getuserdatafromLabsForiscentertrue();
                    // console.log(this.role);
                });
            }
        });

        this.settingFormOne = this.formBuilder.group({
            labListName: ["", Validators.required],
        });

        this.settingFormTwo = this.formBuilder.group({
            centerListName: ["", Validators.required],
        });

        this.settingFormThree = this.formBuilder.group({
            zoneListName: ["", Validators.required],
        });

        this.settingFormFour = this.formBuilder.group({
            languageListName: ["", Validators.required],
        });
    }

    getROleconfiguration() {
        const loginUserRole = this.userService.getCookie("role");
        // // // console.log(e);
        this.apiService.getAllRoleByName(loginUserRole).subscribe(
            (a) => {
                Object.entries(a).find(([key, value]) => {
                    if (key == "data") {
                        this.allConfigurationByrole = value;
                        this.allConfigurationByrole.forEach((element) => {
                            this.currentRoleData = element.access_specifier;
                            for (const [key, value] of Object.entries(
                                this.currentRoleData,
                            )) {
                                // // // console.log(`);
                                this.can_change_centre =
                                    this.currentRoleData.can_change_centre;
                                this.can_change_lab =
                                    this.currentRoleData.can_change_lab;
                            }
                        });
                        // // // console.log(e);
                    } else {
                    }
                });
            },
            (err) => {
                this.errorMessage = err.error.message;
                // // // console.log(e);
                if (err.status == 401) {
                    alert(this.translateSentence("Login.InvalidToken"));
                    this.logout();
                }
            },
        );
    }

    async getuserdatafromLabs(): Promise<void> {
        return new Promise((resolve, reject) => {
            const lab_id = this.userService.getCookie("lab_id");
            this.centers = this.userService.getCookie("center");
            this.apiservice.getALlLabs().subscribe(
                (a) => {
                    Object.entries(a).find(([key, value]) => {
                        if (key == "data") {
                            this.labsData = value;
                            this.newlablist = [];
                            this.labsData.forEach((element) => {
                                this.newlablist.push(element);
                                this.Labs = element.lab_id;
                                this.lablist.push(this.Labs);
                                if (lab_id === this.Labs) {
                                    this.ismultiCenter = element.multi_center;
                                    let uniqueArray = element.centers;
                                    this.centresType = uniqueArray.filter(
                                        (item, index) => {
                                            return (
                                                uniqueArray.indexOf(item) ===
                                                index
                                            );
                                        },
                                    );
                                }
                            });

                            this.newlablist.sort((a, b) =>
                                a.lab_name.localeCompare(b.lab_name),
                            );

                            this.lablist = this.lablist.filter(
                                (item, index) => {
                                    return this.lablist.indexOf(item) === index;
                                },
                            );
                            resolve();
                        } else {
                            resolve();
                        }
                    });
                },

                (err) => {
                    this.errorMessage = err.error.message;
                    // // // console.log(e);
                    if (err.status == 401) {
                        // // // console.log(");,
                        alert(this.translateSentence("Login.InvalidToken"));
                        this.logout();
                    }
                    reject(err);
                },
            );
        });
    }

    async getuserdatafromLabsForiscentertrue(): Promise<void> {
        const lab_id = this.userService.getCookie("lab_id");
        this.centers = this.userService.getCookie("center");
        // // // console.log(s);

        this.apiservice.getALlLabs().subscribe(
            (a) => {
                Object.entries(a).find(([key, value]) => {
                    if (key == "data") {
                        const data1 = value;
                        data1.forEach((element) => {
                            // // // console.log(d);
                            if (lab_id === element.lab_id) {
                                this.ismultiCenter = element.multi_center;
                                // // console.log( );
                                let uniqueArray = element.centers;
                                this.centresType = uniqueArray.filter(
                                    (item, index) => {
                                        return (
                                            uniqueArray.indexOf(item) === index
                                        );
                                    },
                                );
                            }
                        });
                    } else {
                        // // // console.log(e);
                    }
                });
            },

            (err) => {
                this.errorMessage = err.error.message;
                // // // console.log(e);
                if (err.status == 401) {
                    alert(this.translateSentence("Login.InvalidToken"));
                    this.logout();
                }
            },
        );
    }

    async getLabArrayForExistRecordComaparission(): Promise<void> {
        this.uesrDocId = "";
        const token = this.userService.getCookie("token");
        const email = this.userService.getCookie("email");
        this.apiservice.getAllLabID(token, email).subscribe(
            (a) => {
                Object.entries(a).find(([key, value]) => {
                    if (key == "data") {
                        this.labsDataIdsforSupport = value;
                        // this.existingUserLabs = value;
                        this.labsDataIdsforSupport.forEach((element) => {
                            this.existingUserLabs = element.labs;
                            // // console.log(s);
                        });
                    } else {
                        // // // console.log(e);
                    }
                });
            },
            (err) => {
                this.errorMessage = err.error.message;
                // // // console.log(e);
                if (err.status == 401) {
                    alert(this.translateSentence("Login.InvalidToken"));
                    this.logout();
                }
            },
        );
    }

    async getuserdatafromUser(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.uesrDocId = "";
            const token = this.userService.getCookie("token");
            const email = this.userService.getCookie("email");
            this.apiservice.getAllLabID(token, email).subscribe(
                (a) => {
                    Object.entries(a).find(([key, value]) => {
                        if (key == "data") {
                            this.userLabsData = value;
                            this.userLabsData.forEach((element) => {
                                this.totalLabs = element.labs;
                                this.uesrDocId = element._id;
                                this.existingUserLabs = element.labs;
                            });
                            this.newlablist = [];
                            // this.lablist = this.totalLabs.map(obj => {
                            this.labsData.forEach((obj, index) => {
                                this.totalLabs.forEach((elementLab) => {
                                    if (obj.lab_id == elementLab.lab_id) {
                                        this.newlablist.push(obj);
                                        // // console.log(]);
                                    }
                                });
                            });

                            resolve();

                            // // console.log(t);
                        } else {
                            resolve();
                        }
                    });
                },

                (err) => {
                    this.errorMessage = err.error.message;
                    // // // console.log(e);
                    if (err.status == 401) {
                        alert(this.translateSentence("Login.InvalidToken"));
                        this.logout();
                    }
                    reject(err);
                },
            );
        });
    }

    centerOnChangeVal(centerId) {
        // // console.log(d);
        this.currentCenter = centerId;
    }

    labOnChangeVal(labId) {
        // // // console.log(d);
        this.currentLab = labId;
    }

    zoneOnChangeVal(event) {
        // // // console.log(t);
    }
    updateLab() {
        const role = this.userService.getCookie("role");
        if (this.selectedLab === this.settingFormOne.value.labListName) {
            alert(this.translateSentence("LabSettings.LabSettingMessage1"));
            return false;
        }

        const SelectlabId = this.settingFormOne.value.labListName;
        this.getTimeZone(SelectlabId);
    }

    getTimeZone(labId) {
        const labInfo = this.existingUserLabs.find(
            (obj) => obj.lab_id === labId,
        );
        this.changedCenter = labInfo?.center || "";
        const defaultrole = labInfo?.role || this.role;

        const labData = {
            email: this.userId,
            update_data: {
                labs: [
                    {
                        lab_id: labId,
                        role: defaultrole,
                        default_lab: true,
                        center: this.changedCenter,
                    },
                ],
                updated: (-1 * new Date().getTime()).toString(),
                enabled: true,
            },
        };
        // console.log(labData);
        // update lab in user collection with center blank, with default user role, default lab true
        this.labService.updateUserLabDetail(labData).subscribe((data) => {
            Object.entries(data).find(([key, value]) => {
                if (
                    key == "status" &&
                    (value == "success" || value == "Success")
                ) {
                    const msg = `${this.translateSentence(
                        "LabSettings.LabSettingMessage2",
                    )}- ${labId}, ${this.translateSentence(
                        "LabSettings.LabSettingMessage3",
                    )}`;
                    alert(msg);
                    this.logout();
                } else if (key == "status" && value == "failed") {
                    const msg = this.translateSentence(
                        "LabSettings.DataNotUpdated",
                    );
                    // this.openSnackBar(msg, 'OK');
                    alert(msg);
                }
            });
        });
    }

    updateZone() {
        // // // console.log(e);
        const lab_id = this.userService.getCookie("lab_id");
        const timeZone: string = this.settingFormThree.value.zoneListName;
        // // // console.log(e);
        const labData = {
            lab_id: lab_id,
            update_data: {
                default_time_zone: timeZone,
            },
        };
        this.labService.updateLab(labData).subscribe((data) => {
            Object.entries(data).find(([key, value]) => {
                if (key == "data") {
                    this.memberInfo = value;
                    this.memberInfo.forEach((element) => {
                        this.memberId = element._id;
                        localStorage.setItem("defaultTz", timeZone);
                        alert(
                            this.translateSentence(
                                "LabSettings.TimezoneUpdatedMessage",
                            ),
                        );
                    });
                } else if (key == "status" && value == "failed") {
                    alert(
                        this.translateSentence(
                            "LabSettings.TimezoneNotUpdatedMessage",
                        ),
                    );
                }
            });
        });
    }

    updateCenter() {
        // const lab_id = this.userService.getCookie("lab_id")
        if (this.selectedCenter === this.settingFormTwo.value.centerListName) {
            alert(this.translateSentence("LabSettings.CenterUpdatedMessage1"));
            return false;
        }

        const centerId: string = this.settingFormTwo.value.centerListName;
        const lab_id = this.settingFormOne.value.labListName;
        // this.getTimeZone(lab_id);
        let defaultrole;
        let existlabId;
        if (this.existingUserLabs.length > 0) {
            this.existingUserLabs.map((obj) => {
                // if(this.multi_center == true){
                //     this.changedCenter = obj.center;
                // }else if(this.multi_center == false){
                //     this.changedCenter = "";
                // }
                defaultrole = obj.role;
                existlabId = obj.lab_id;
                this.changedCenter = obj.center;
            });
        }
        // console.log("Existing user labs:", this.existingUserLabs);
        const labData = {
            email: this.userId,
            update_data: {
                labs: [
                    {
                        lab_id: lab_id || existlabId,
                        role: defaultrole,
                        default_lab: true,
                        center: centerId,
                    },
                ],
                updated: (-1 * new Date().getTime()).toString(),
                enabled: true,
            },
        };
        //update lab in user collection with center blank, with default user role, default lab true
        this.labService.updateUserLabDetail(labData).subscribe((data) => {
            Object.entries(data).find(([key, value]) => {
                if (
                    key == "status" &&
                    (value == "success" || value == "Success")
                ) {
                    const msg = `${this.translateSentence(
                        "LabSettings.CenterUpdatedMessage2",
                    )}- ${centerId}, ${this.translateSentence(
                        "LabSettings.CenterUpdatedMessage3",
                    )}`;
                    alert(msg);
                    this.logout();
                } else if (key == "status" && value == "failed") {
                    const msg = this.translateSentence(
                        "LabSettings.DataNotUpdated",
                    );
                    // this.openSnackBar(msg, 'OK');
                    alert(msg);
                }
            });
        });
    }

    logout(): void {
        const keep = new Set(["language"]);
        Object.keys(localStorage).forEach((key) => {
            if (!keep.has(key)) {
                localStorage.removeItem(key);
            }
        });
        this.userService.clearCookie();
        this.reminderService.clear();
        this.globals.cassetteConfig = null;
        this.router.navigate(["/login"]).then(() => {
            window.location.reload();
        });
    }

    getuserDatails() {
        const token = this.userService.getCookie("token");
        const email = this.userService.getCookie("email");

        this.apiService.getAllLabID(token, email).subscribe(
            (a) => {
                Object.entries(a).find(([key, value]) => {
                    if (key == "data") {
                        this.memberInfo = value;
                        this.memberInfo.forEach((element) => {
                            this.userId = element.email;
                        });
                    } else if (key == "status" && value == "failed") {
                        alert(
                            this.translateSentence(
                                "LabSettings.EmailNotExists",
                            ),
                        );
                    }
                });
            },
            (err) => {
                this.errorMessage = err.error.message;
                // // // console.log(e);
                if (err.status == 401) {
                    alert(this.translateSentence("Login.InvalidToken"));
                    this.logout();
                }
            },
        );
    }

    changeLanguage(language: string) {
        this.currentLanguage = language;
        this.dateAdapter.setLocale(language);
        this.userService.setCookie("language", language);

        const userObj = {
            email: this.email,
            update_data: {
                preferred_language: this.currentLanguage,
            },
        };

        this.labService.updateUserInfo(userObj).subscribe((res) => {
            // console.log(res);
        });

        this.translate.use(language).subscribe(() => {
            const displayLanguage = this.languages
                .map((lang) => (lang.code === language ? lang.name : null))
                .filter((name) => name)[0];

            alert(
                `${this.translate.instant(
                    "LabSettings.LanguageUpdatedMessage",
                )} ${this.translate.instant(displayLanguage)}`,
            );

            window.location.reload();
        });
    }

    languageOnChangeVal(event) {
        // console.log(event);
        this.currentLanguage = event;
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }
}
